module.exports = __webpack_public_path__ + "static/media/graphql.509fe10a.svg";